const fontFamilies = {
  body: 'Lato, Arial, sans-serif',
  heading: 'Playfair Display, Georgia, serif'
};

export default fontFamilies;
